import React, { useReducer } from "react";
import AdminContext from "./adminContext";
import adminReducer from "./adminReducer";
import { API_BASE, apiErrorMessage, authedFetch } from "../../utils/api";
import { GET_USERS, GET_USERS_ERROR, UPDATE_USER_ROLE, UPDATE_USER_ROLE_ERROR } from "../types";

const AdminState = (props) => {
  const initialState = {
    users: [],
    usersPage: 1,
    usersTotal: 0,
    usersHasMore: false,
    usersPageSize: 20,
    loading: true,
  };

  const [state, dispatch] = useReducer(adminReducer, initialState);

  const getUsers = async (page = 1, pageSize = 20) => {
    const res = await authedFetch(
      `${API_BASE}/users?page=${page}&page_size=${pageSize}`,
      { method: "GET", headers: { "Content-Type": "application/json" } }
    );
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_USERS, payload: res_json });
    } else {
      dispatch({ type: GET_USERS_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const updateUserRole = async (userId, role) => {
    const formData = new FormData();
    formData.append("role", role);
    const res = await authedFetch(`${API_BASE}/user/${userId}/role`, {
      method: "PUT",
      body: formData,
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: UPDATE_USER_ROLE, payload: res_json });
      return { ok: true };
    } else {
      dispatch({ type: UPDATE_USER_ROLE_ERROR, payload: apiErrorMessage(res_json) });
      return { ok: false, msg: apiErrorMessage(res_json) };
    }
  };

  return (
    <AdminContext.Provider
      value={{
        users: state.users,
        usersPage: state.usersPage,
        usersTotal: state.usersTotal,
        usersHasMore: state.usersHasMore,
        usersPageSize: state.usersPageSize,
        loading: state.loading,
        getUsers,
        updateUserRole,
      }}
    >
      {props.children}
    </AdminContext.Provider>
  );
};

export default AdminState;
